import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './auth/config.service';
import { Router } from '@angular/router';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeDataService {

constructor(private http: HttpClient, private configService: ConfigService, private router: Router) { }



// Dashboard Stats
getDashboardStats() {
  const apiUrl = `${this.configService.getApiUrl()}/HomeData/stats`;

  return this.http.get<any>(apiUrl).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Dashboard Stats failed.'));
    })
  );
}


// Notifications
getNotifications() {
  const apiUrl = `${this.configService.getApiUrl()}/HomeData/notifications`;

  return this.http.get<any>(apiUrl).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Notifications retrieval failed.'));
    })
  );
}


// Society Types
getSocietyTypes() {
  const apiUrl = `${this.configService.getApiUrl()}/HomeData/society-types`;

  return this.http.get<any>(apiUrl).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Society Types retrieval failed.'));
    })
  );
}


// Society Summary
getSocietySummary() {
  const apiUrl = `${this.configService.getApiUrl()}/HomeData/society-summary`;

  return this.http.get<any>(apiUrl).pipe(
    map((response) => {
      return response;
    }),
    catchError((err) => {
      return throwError(() => new Error('Society Summary retrieval failed.'));
    })
  );
}
  

}
